import React from "react";
import { Route, Router, Switch } from 'react-router-dom'

import 'assets/scss/material-dashboard-pro-react.css?v=1.4.0'
import "react-vis/dist/style.css"
import DownloadPage from "./routes/DownloadPage";
import {createBrowserHistory} from 'history'

export const history = createBrowserHistory();

function App() {
     return (
        <Router history={history}>
            <Switch>
              <Route exact path="/" component={DownloadPage}/>
            </Switch>
        </Router>);
}

export default App;